// import Printable from "components/modules/reporting/A4";
// import React, { useRef } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import { formatDate } from "utils/dateFormatter";
// import logo from "../../../../assets/img/logos/logoNew.png";

// export default function VoucherReport() {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const printRef = useRef();

//   const triggerPrint = () => {
//     printRef.current?.handlePrint?.();
//   };

//   const totalDebit = state?.entries?.reduce(
//     (sum, entry) => sum + (entry.debit || 0),
//     0
//   );
//   const totalCredit = state?.entries?.reduce(
//     (sum, entry) => sum + (entry.credit || 0),
//     0
//   );

//   return (
//     <>
//       <Card>
//         <Card.Header className="border-bottom">
//           <Row className="flex-between-center ">
//             <Col md>
//               <div className="d-flex align-items-center">
//                 <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                   {" "}
//                   Reports | Voucher
//                 </h5>
//                 <div className="d-flex align-items-center gap-2 mx-4">
//                   <span style={{ color: "black" }}>Vouhcer Number:</span>
//                   <Form.Group className="" controlId="formGroupBod">
//                     {/* <Form.Label>From Date: </Form.Label> */}
//                     <Form.Control
//                       type="text"
//                       placeholder="Enter Voucher Number"
//                     />
//                   </Form.Group>
//                   <span style={{ color: "black" }}>From Date:</span>
//                   <Form.Group className="" controlId="formGroupBod">
//                     {/* <Form.Label>From Date: </Form.Label> */}
//                     <Form.Control type="date" />
//                   </Form.Group>
//                   <span style={{ color: "black" }}>To Date:</span>
//                   <Form.Group className="" controlId="formGroupBod">
//                     {/* <Form.Label>To Date:</Form.Label> */}
//                     <Form.Control type="date" />
//                   </Form.Group>
//                 </div>
//               </div>
//             </Col>
//             <Col xs="auto">
//               <Button
//                 variant="link"
//                 className="text-secondary fw-medium p-0 me-3"
//                 type="button"
//                 onClick={() => navigate(-1)}
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" onClick={triggerPrint}>
//                 Print
//               </Button>
//             </Col>
//           </Row>
//         </Card.Header>

//         <Printable ref={printRef} documentTitle="Journal Voucher">
//           <div style={{ padding: 40, fontFamily: "Arial, sans-serif" }}>
//             {/* Header */}
//             <div className="d-flex justify-content-between">
//               <div>
//                 <div style={{ textAlign: "center", color: "black" }}>
//                   <img
//                     height={80}
//                     width={80}
//                     src={logo}
//                     alt="Logo"
//                     style={{ marginBottom: "20px" }}
//                   />
//                 </div>
//                 <h4 style={{ textAlign: "center", color: "black" }}>
//                   {state?.type} Voucher
//                 </h4>
//               </div>
//               <div></div>
//             </div>

//             {/* Reference and Company */}
//             <div className="d-flex justify-content-between my-4">
//               <div>
//                 <strong>Company Name:</strong> ABC Corporation
//                 <br />
//                 <strong>Address:</strong> 123 Main St, City, Country
//               </div>
//               <div className="text-end">
//                 <div>
//                   <strong>REF. NO.:</strong> 123123124
//                 </div>
//                 <div>
//                   <strong>Generated:</strong> {new Date().toLocaleDateString()}
//                 </div>
//               </div>
//             </div>

//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 marginBottom: 20,
//               }}
//             >
//               <thead>
//                 <tr>
//                   <th style={styles.th}>SR NO.</th>
//                   <th style={styles.th}>A/C NAME</th>
//                   <th style={styles.th}>SUB LEDGER</th>
//                   <th style={styles.th}>DESCRIPTION</th>
//                   <th style={styles.th}>DEBIT</th>
//                   <th style={styles.th}>CREDIT</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {state?.entries?.map((d, index) => (
//                   <tr key={index}>
//                     <td style={styles.td}>{index + 1}</td>
//                     <td style={styles.td}>{d.accountTitle}</td>
//                     <td style={styles.td}>{d.subLedgerName}</td>
//                     <td style={styles.td}>{d.description}</td>
//                     <td style={styles.tdP}>{d.debit?.toLocaleString()}</td>
//                     <td style={styles.tdP}>{d.credit?.toLocaleString()}</td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot>
//                 <tr>
//                   <td colSpan={4} style={styles.tdFT} className="bold">
//                     Total:{" "}
//                   </td>
//                   <td style={styles.tdF}>{totalDebit?.toLocaleString()}</td>
//                   <td style={styles.tdF}>{totalCredit?.toLocaleString()}</td>
//                 </tr>
//               </tfoot>
//             </table>

//             {/* <div
//               style={{
//                 textAlign: "right",
//                 fontWeight: "bold",
//                 marginBottom: 40,
//               }}
//             >
//               <div>Total Debit: {totalDebit.toLocaleString()}</div>
//               <div>Total Credit: {totalCredit.toLocaleString()}</div>
//             </div> */}

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginTop: 60,
//               }}
//             >
//               <div>APPROVED BY:</div>
//               <div
//                 style={{ borderBottom: "1px solid #000", width: "250px" }}
//               ></div>
//             </div>
//           </div>
//         </Printable>
//       </Card>
//     </>
//   );
// }

// const styles = {
//   printBtn: {
//     padding: "5px 10px",
//     backgroundColor: "#4CAF50",
//     color: "white",
//     border: "none",
//     borderRadius: "2px",
//     cursor: "pointer",
//     marginRight: "40px",
//   },
//   th: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//     fontWeight: "bold",
//   },
//   td: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//   },
//   tdP: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//   },
//   tdFT: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//   },
//   tdF: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//     backgroundColor: "#e6e6e6",
//   },
// };

// import Printable from "components/modules/reporting/A4";
// import React, { useEffect, useRef, useState } from "react";
// import { Button, Card, Col, Collapse, Form, Row } from "react-bootstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import logo from "../../../../assets/img/logos/logoNew.png";
// import { formatDateRange } from "utils/formatter";
// import ReactDatePickerE from "components/common/ReactDatePickerE";
// import {
//   IoIosArrowDropdown,
//   IoIosArrowDropright,
//   IoIosArrowDropup,
// } from "react-icons/io";

// export default function VoucherReport() {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const printRef = useRef();

//   const formatAmount = (amount) =>
//     amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

//   const triggerPrint = () => {
//     printRef.current?.handlePrint?.();
//   };

//   // Sample data
//   const defaultState = {
//     type: "Journal",
//     voucherNumber: "JV-2023-001",
//     date: new Date().toISOString(),
//     entries: [
//       {
//         accountTitle: "Office Expenses",
//         subLedgerName: "Stationary",
//         description: "Printer paper and ink",
//         debit: 25000,
//         credit: 0,
//       },
//       {
//         accountTitle: "Cash Account",
//         subLedgerName: "Main Cash",
//         description: "Payment for office supplies",
//         debit: 0,
//         credit: 25000,
//       },
//     ],
//   };

//   const data = state || defaultState;
//   const totalDebit = data.entries.reduce(
//     (sum, entry) => sum + (entry.debit || 0),
//     0
//   );
//   const totalCredit = data.entries.reduce(
//     (sum, entry) => sum + (entry.credit || 0),
//     0
//   );

//   // Get initial dates
//   const today = new Date();
//   const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

//   // State for dates
//   const [fromDate, setFromDate] = useState(formatDateRange(firstDayOfMonth));
//   const [toDate, setToDate] = useState(formatDateRange(today));

//   const [showFilters, setShowFilters] = useState(false);
//   const [collapseIn, setCollapseIn] = useState(false);

//   const toggleFilters = () => {
//     if (collapseIn) {
//       // Collapse first
//       setCollapseIn(false);
//       setTimeout(() => setShowFilters(false), 300); // match Collapse animation duration
//     } else {
//       setShowFilters(true); // render first
//       setTimeout(() => setCollapseIn(true), 10); // short delay to trigger animation
//     }
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const header = document.querySelector(".sticky-header");
//       if (header) {
//         const headerBottom = header.getBoundingClientRect().bottom;
//         const button = document.querySelector(".collapse-button");
//         button.style.visibility = headerBottom > 0 ? "visible" : "hidden";
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <Card>
//       {/* <Card.Header className="border-bottom">
//         <Row className="flex-between-center">
//           <Col md>
//             <div className="d-flex align-items-center">
//               <h5
//                 className="fs-9 text-nowrap mb-2 mb-md-0"
//                 style={{ width: "19.5rem" }}
//               >
//                 Reports | Voucher
//               </h5>
//               <div
//                 className="d-flex align-items-center gap-2"
//                 // style={{ marginLeft: "8.4rem" }}
//               >
//                 <Form.Group
//                   controlId="formGroupVoucherNumber"
//                   style={{ width: "200px" }}
//                 >
//                   <Form.Control type="text" placeholder="Voucher Number" />
//                 </Form.Group>
//                 <div style={{ color: "black" }}>Date Range:</div>
//                 <div
//                   style={{
//                     width: "200px",
//                   }}
//                 >
//                   <ReactDatePickerE />
//                 </div>
//               </div>
//             </div>
//           </Col>
//           <Col xs="auto">
//             <Button
//               variant="link"
//               className="text-secondary fw-medium p-0 me-3"
//               onClick={() => navigate(-1)}
//             >
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={triggerPrint}>
//               Print
//             </Button>
//           </Col>
//         </Row>
//       </Card.Header> */}

//       <Card.Header className="border-bottom">
//         <div className="header-content">
//           <Row className="flex-between-center align-items-center">
//             <Col md>
//               <div className="d-flex align-items-center flex-wrap gap-2">
//                 <h5
//                   className="fs-9 text-nowrap mb-2 mb-md-0"
//                   style={{ width: "19.5rem" }}
//                 >
//                   Reports | Voucher
//                 </h5>

//                 <div style={{ color: "black" }}>Date Range:</div>
//                 <div style={{ width: "250px" }}>
//                   <ReactDatePickerE />
//                 </div>
//               </div>
//             </Col>

//             <Col xs="auto">
//               <>
//                 {collapseIn ? (
//                   <div style={{ position: "fixed" }}>
//                     {" "}
//                     <IoIosArrowDropup
//                       title="Hide Filters"
//                       size={30}
//                       onClick={toggleFilters}
//                       // className="collapse-icon-custome"
//                       className="cursor-pointer"
//                       style={{ borderRadius: "100%" }}
//                     />
//                   </div>
//                 ) : (
//                   <div style={{ position: "fixed" }}>
//                     <IoIosArrowDropdown
//                       title="Show Filters"
//                       size={30}
//                       onClick={toggleFilters}
//                       className="cursor-pointer"
//                       style={{ borderRadius: "100%" }}
//                     />
//                   </div>
//                 )}
//               </>
//               <Button
//                 variant="link"
//                 className="text-secondary fw-medium p-0 me-3"
//                 onClick={() => navigate(-1)}
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" onClick={triggerPrint}>
//                 Print
//               </Button>
//             </Col>
//           </Row>

//           <Collapse in={collapseIn}>
//             <div className="filter-row">
//               <Row className="mt-3">
//                 <Col md="auto">
//                   <Form.Group
//                     controlId="formGroupVoucherNumber"
//                     style={{ width: "200px" }}
//                   >
//                     <Form.Control type="text" placeholder="Voucher Number" />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>
//           </Collapse>
//         </div>
//       </Card.Header>

//       <Printable ref={printRef} documentTitle="Journal Voucher">
//         <div style={{ padding: 40, fontFamily: "Arial, sans-serif" }}>
//           {/* Header */}
//           <div className="d-flex justify-content-between">
//             <div>
//               <div style={{ textAlign: "center", color: "black" }}>
//                 <img
//                   height={80}
//                   width={80}
//                   src={logo}
//                   alt="Logo"
//                   style={{ marginBottom: "20px" }}
//                 />
//               </div>
//               <h4 style={{ textAlign: "center", color: "black" }}>
//                 {data.type} Voucher
//               </h4>
//             </div>
//             <div></div>
//           </div>

//           {/* Reference and Company */}
//           <div className="d-flex justify-content-between my-4">
//             <div>
//               <strong>Company Name:</strong> ABC Corporation
//               <br />
//               <strong>Address:</strong> 123 Main St, City, Country
//             </div>
//             <div className="text-end">
//               <div>
//                 <strong>Reference #:</strong> {data.voucherNumber}
//               </div>
//               <div>
//                 <strong>Printed:</strong> {new Date().toLocaleDateString()}
//               </div>
//             </div>
//           </div>

//           {/* Voucher Table */}
//           <div style={{ marginTop: 30 }}>
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.th}>SR NO.</th>
//                   <th style={styles.th}>A/C NAME</th>
//                   <th style={styles.th}>SUB LEDGER</th>
//                   <th style={styles.th}>DESCRIPTION</th>
//                   <th style={styles.th}>DEBIT</th>
//                   <th style={styles.th}>CREDIT</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.entries?.map((entry, index) => (
//                   <tr key={index}>
//                     <td style={styles.td}>{index + 1}</td>
//                     <td style={styles.td}>{entry.accountTitle}</td>
//                     <td style={styles.td}>{entry.subLedgerName}</td>
//                     <td style={styles.td}>{entry.description}</td>
//                     <td style={styles.tdP}>
//                       {entry.debit ? formatAmount(entry.debit) : "-"}
//                     </td>
//                     <td style={styles.tdP}>
//                       {entry.credit ? formatAmount(entry.credit) : "-"}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot>
//                 <tr>
//                   <td colSpan={4} style={styles.tdTotal}>
//                     <strong>TOTAL</strong>
//                   </td>
//                   <td style={styles.tdTotalP}>
//                     <strong>{formatAmount(totalDebit)}</strong>
//                   </td>
//                   <td style={styles.tdTotalP}>
//                     <strong>{formatAmount(totalCredit)}</strong>
//                   </td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>

//           {/* Approval Signature */}
//           <div
//             style={{
//               marginTop: 100,
//               display: "flex",
//               justifyContent: "flex-end",
//             }}
//           >
//             <div style={{ width: 300, textAlign: "center" }}>
//               <div
//                 style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
//               ></div>
//               <div>Authorized Signature</div>
//             </div>
//           </div>
//         </div>
//       </Printable>
//     </Card>
//   );
// }

// const border = "1px solid #000";
// const basePadding = "8px 10px";
// const baseTextAlignLeft = "left";
// const baseTextAlignRight = "right";

// const bg = {
//   lightGray: "#f8f8f8",
//   gray: "#e6e6e6",
//   darkGray: "#A9A9A9",
// };

// const styles = {
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginBottom: 20,
//   },
//   th: {
//     border,
//     padding: basePadding,
//     textAlign: baseTextAlignLeft,
//     backgroundColor: bg.darkGray,
//     fontWeight: "bold",
//   },
//   td: {
//     border,
//     // borderRight: "none",
//     padding: basePadding,
//     textAlign: baseTextAlignLeft,
//   },
//   tdP: {
//     border,
//     // borderLeft: "none",
//     padding: basePadding,
//     textAlign: baseTextAlignRight,
//   },
//   tdTotal: {
//     border,
//     // borderRight: "none",
//     padding: basePadding,
//     textAlign: baseTextAlignLeft,
//     fontWeight: "bold",
//     backgroundColor: bg.darkGray,
//   },
//   tdTotalP: {
//     border,
//     // borderLeft: "none",
//     padding: basePadding,
//     textAlign: baseTextAlignRight,
//     fontWeight: "bold",
//     backgroundColor: bg.darkGray,
//   },
// };

// <style>
//   {`
//   .sticky-header {
//     position: sticky;
//     top: 0;
//     background: white;
//     z-index: 1000;
//     transition: all 0.3s;
//   }

//   .border-bottom {
//     border-bottom: 1px solid #dee2e6 !important;
//   }
// `}
// </style>;

// ==========================

import Printable from "components/modules/reporting/A4";
import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Collapse, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/img/logos/logoNew.png";
import { formatDateRange } from "utils/formatter";
import ReactDatePickerE from "components/common/ReactDatePickerE";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import PageTitle from "utils/PageTitle";

export default function VoucherReport() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const printRef = useRef();
  const headerRef = useRef();
  const collapseButtonRef = useRef();

  const [reportData, setReportData] = useState(null);

  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  // Sample data
  const defaultState = {
    type: "Journal",
    voucherNumber: "JV-2023-001",
    date: new Date().toISOString(),
    entries: [
      {
        accountTitle: "Office Expenses",
        subLedgerName: "Stationary",
        description: "Printer paper and ink",
        debit: 25000,
        credit: 0,
      },
      {
        accountTitle: "Cash Account",
        subLedgerName: "Main Cash",
        description: "Payment for office supplies",
        debit: 0,
        credit: 25000,
      },
    ],
  };

  const data = state || defaultState;
  const totalDebit = data.entries.reduce(
    (sum, entry) => sum + (entry.debit || 0),
    0
  );
  const totalCredit = data.entries.reduce(
    (sum, entry) => sum + (entry.credit || 0),
    0
  );

  // State for dates
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [fromDate, setFromDate] = useState(formatDateRange(firstDayOfMonth));
  const [toDate, setToDate] = useState(formatDateRange(today));

  const [collapseIn, setCollapseIn] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const toggleFilters = () => setCollapseIn(!collapseIn);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const rect = headerRef.current.getBoundingClientRect();
        setIsHeaderVisible(rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <PageTitle name="Reports | Voucher" />
      <Card>
        <Card.Header
          ref={headerRef}
          className="border-bottom sticky-header"
          style={{
            position: "sticky",
            top: -90,
            backgroundColor: "white",
            zIndex: 1000,
            paddingBottom: collapseIn ? "1rem" : "1.5rem",
            transition: "padding-bottom 0.3s ease",
          }}
        >
          <div className="header-content">
            <Row className="flex-between-center align-items-center">
              <Col md>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <h5
                    className="fs-9 text-nowrap mb-2 mb-md-0"
                    style={{ width: "19.5rem" }}
                  >
                    Reports | Voucher
                  </h5>
                  <div style={{ color: "black" }}>Date Range:</div>
                  <div style={{ width: "280px" }}>
                    <ReactDatePickerE />
                  </div>
                </div>
              </Col>
              <Col xs="auto">
                <Button
                  variant="link"
                  className="text-secondary fw-medium p-0 me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                {reportData ? (
                  <>
                    <Button variant="primary" onClick={triggerPrint}>
                      Print
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="primary">Preview</Button>
                  </>
                )}
              </Col>
            </Row>

            <Collapse in={collapseIn}>
              <div className="filter-row">
                <Row className="mt-3">
                  <Col md="auto" style={{ marginLeft: "20rem" }}>
                    <Form.Group
                      controlId="formGroupVoucherNumber"
                      style={{ width: "200px" }}
                    >
                      <Form.Control type="text" placeholder="Voucher Number" />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>

          {/* Collapse toggle button fixed to border-bottom */}
          <div
            ref={collapseButtonRef}
            style={{
              position: "absolute",
              right: "7.5rem",
              bottom: "-15px",
              zIndex: 1001,
              backgroundColor: "white",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px white",
              visibility: isHeaderVisible ? "visible" : "hidden",
              transition: "visibility 0.2s ease",
            }}
          >
            {collapseIn ? (
              <IoIosArrowDropup
                title="Hide Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            ) : (
              <IoIosArrowDropdown
                title="Show Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            )}
          </div>
        </Card.Header>

        <Printable ref={printRef} documentTitle="Journal Voucher">
          {/* Printable content remains the same */}
          {reportData && (
            <div
              style={{
                padding: 40,
                // fontFamily: "Arial, sans-serif",
                fontSize: "14px",
              }}
            >
              {/* Header */}
              <div className="d-flex justify-content-between">
                <div>
                  <div style={{ textAlign: "center", color: "black" }}>
                    <img
                      height={80}
                      width={80}
                      src={logo}
                      alt="Logo"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                  <h4 style={{ textAlign: "center", color: "black" }}>
                    {data.type} Voucher
                  </h4>
                </div>
                <div></div>
              </div>

              {/* Reference and Company */}
              <div className="d-flex justify-content-between my-4">
                <div>
                  <strong>Company Name:</strong> ABC Corporation
                  <br />
                  <strong>Address:</strong> 123 Main St, City, Country
                </div>
                <div className="text-end">
                  <div>
                    <strong>Reference #:</strong> {data.voucherNumber}
                  </div>
                  <div>
                    <strong>Printed:</strong> {new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* Voucher Table */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>SR NO.</th>
                      <th style={styles.th}>A/C NAME</th>
                      <th style={styles.th}>SUB LEDGER</th>
                      <th style={styles.th}>DESCRIPTION</th>
                      <th style={styles.th}>DEBIT</th>
                      <th style={styles.th}>CREDIT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.entries?.map((entry, index) => (
                      <tr key={index}>
                        <td style={styles.td}>{index + 1}</td>
                        <td style={styles.td}>{entry.accountTitle}</td>
                        <td style={styles.td}>{entry.subLedgerName}</td>
                        <td style={styles.td}>{entry.description}</td>
                        <td style={styles.tdP}>
                          {entry.debit ? formatAmount(entry.debit) : "-"}
                        </td>
                        <td style={styles.tdP}>
                          {entry.credit ? formatAmount(entry.credit) : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={4} style={styles.tdTotal}>
                        <strong>TOTAL</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(totalDebit)}</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(totalCredit)}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Approval Signature */}
              <div
                style={{
                  marginTop: 100,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ width: 300, textAlign: "center" }}>
                  <div
                    style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
                  ></div>
                  <div>Authorized Signature</div>
                </div>
              </div>
            </div>
          )}
        </Printable>
      </Card>
    </>
  );
}

const border = "1px solid #000";
const basePadding = "8px 10px";
const baseTextAlignLeft = "left";
const baseTextAlignRight = "right";

const bg = {
  darkGray: "#A9A9A9",
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
  },
  th: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.darkGray,
    fontWeight: "bold",
  },
  td: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
  },
  tdP: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignRight,
  },
  tdTotal: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdTotalP: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
};
